<template>
  <div class="animated fadeIn container">
    <CRow class="justify-content-md-center">
      <CCol sm="12" md="6">
        <CCard>
          <CCardHeader>{{$t("change_email")}}</CCardHeader>
          <CCardBody>
            <p>{{$t("email_message")}}</p>
            <p>{{$t("no_access_to_email")}} <a
              :href="generalComplaintsUrl">{{$t("general_complaints")}}</a>.</p>
            <CRow>
              <CCol sm="12">
                <CInput
                  :label="$t('new_email')"
                  placeholder=""
                  :isValid="email.length > 0 ? validateEmail(email) : null"
                  v-model="email" type="email"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol cols="12" class="text-right">
                <template v-if="reply">
                    <span v-if="!reply.isCaptchaRequired" class="text-success">{{$t("request_confirmation")}}</span>
                    <span v-else>
                  {{ $t('changeEmail.captchaText') }}
                  <a rel="noopener noreferrer" target="_blank" :href="reply.captchaURL">
                    {{ $t('changeEmail.captchaLink') }}
                  </a>.
                </span>
                </template>
                <vue-ladda v-else button-class="btn btn-primary" :loading="loading" :disabled="!validateEmail(email)" @click="submit">
                  {{$t("change_email_button")}}
                </vue-ladda>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow><!--/.row-->

  </div>
</template>

<script>
  import RequestEmailChange from '../../graphql/RequestEmailChange.graphql'
  import i18n from '@/lang/lang'
  import {forumUrl} from '@/services/externalLinks'

  export default {
    data() {
      return {
        loading: false,
        email: '',
        reply: null,
      }
    },
    computed: {
      generalComplaintsUrl () {
        return forumUrl('index.php?forums/general-complaint-area.38/')
      }
    },
    methods: {
      validateEmail(email) {
        let re = /\S+@\S+\.\S+/;
        return re.test(email)
      },
      jwtData() {
        if (this.jwt) {
          let splits = this.jwt.split('.');
          if (splits.length < 2) {
            return null
          }
          return JSON.parse(atob(splits[1]))
        }
        return null
      },
      submit() {
        this.loading = true;
        this.$apollo.mutate({
          mutation: RequestEmailChange,
          variables: {
            newEmail: this.email,
          }
        }).then(data => {
          this.loading = false;
          this.email = '';
          this.reply = data.data.requestEmailChange;
        }).catch(data => {
          this.loading = false;
          this.email = '';
          this.EmailBlacklisted()
        })
      },
    },
    notifications: {
      EmailRequestSent: {
        type: 'info',
        title: i18n.t('request_was_sent'),
        message: i18n.t('request_confirmation')
      },
      EmailBlacklisted: {
        type: 'error',
        title: i18n.t('change_email'),
        message: i18n.t('email_blacklist')
      }
    }
  }
</script>
